import React from 'react';
import { FormItem } from './FormItem';
import { useForm } from '../FormContext';

interface TextareaFieldProps {
  name: string;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  rows?: number;
}

export const TextareaFieldComponent: React.FC<TextareaFieldProps> = ({
  name,
  value,
  onChange,
  onBlur,
  label,
  placeholder,
  required,
  disabled,
  className = "",
  rows = 4,
}) => {
  const { setFieldValue, setFieldTouched, validateField, fields } = useForm();
  const fieldValue = fields[name]?.value || value || "";
  const fieldErrors = fields[name]?.errors || [];
  const hasError = fieldErrors.length > 0;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    setFieldValue(name, newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleBlur = () => {
    setFieldTouched(name, true);
    validateField(name);
    if (onBlur) {
      onBlur();
    }
  };

  const baseClasses = "w-full rounded-md border px-3 py-2 text-sm dark:text-white";
  const errorClasses = hasError ? "border-red-500" : "border-gray-300";
  const disabledClasses = disabled ? "bg-gray-100" : "bg-transparent";
  const finalClasses = `${baseClasses} ${errorClasses} ${disabledClasses} ${className}`;

  return (
      <textarea
        id={name}
        name={name}
        value={fieldValue}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={disabled}
        placeholder={placeholder}
        rows={rows}
        className={finalClasses}
      />
  );
}; 